import { Grid, Typography, Box, BoxProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useHeaderStyles = makeStyles(theme => ({
  card: {
    backgroundColor: '#FFFFFF',
    padding: '16px 24px',
    borderRadius: '8px',
    boxShadow: '16px 16px 32px 0px rgba(69, 69, 127, 0.08)',
  },
}));

export const AppraisalDetailsCard = ({
  children,
  className,
  ...props
}: BoxProps) => {
  const classes = useHeaderStyles();

  return (
    <Box className={clsx(classes.card, className)} {...props}>
      {children}
    </Box>
  );
};
